var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCreditCardColor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_31_1045)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.83301 4.99992C1.83301 4.63173 2.13148 4.33325 2.49967 4.33325H17.4997C17.8679 4.33325 18.1663 4.63173 18.1663 4.99992V7.33325H1.83301V4.99992ZM-0.166992 8.33325V4.99992C-0.166992 3.52716 1.02692 2.33325 2.49967 2.33325H17.4997C18.9724 2.33325 20.1663 3.52716 20.1663 4.99992V8.33325V14.9999C20.1663 16.4727 18.9724 17.6666 17.4997 17.6666H2.49967C1.02692 17.6666 -0.166992 16.4727 -0.166992 14.9999V8.33325ZM18.1663 9.33325V14.9999C18.1663 15.3681 17.8679 15.6666 17.4997 15.6666H2.49967C2.13148 15.6666 1.83301 15.3681 1.83301 14.9999V9.33325H18.1663Z",
    fill: "url(#paint0_linear_31_1045)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_31_1045",
    x1: 20,
    y1: 17.9999,
    x2: -0.0000010338,
    y2: 1.99992,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#492A7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#937ABA"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_31_1045"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCardColor);
export default __webpack_public_path__ + "static/media/CreditCardColor.9efd136c13c065efcdc060bfad143482.svg";
export { ForwardRef as ReactComponent };